// Internal module imports
import { HttpClient } from '../utils/httpClient';

const PATH = {
    read: '/root/mfrr/redis-current-data',
    activationEvents: '/root/mfrr/activation-events',
    commandLogs: '/root/mfrr/command-logs',
    powerLogs: '/root/mfrr/power-logs',
    redisData: '/root/mfrr/redis-data',
    updateRedisValue: '/root/mfrr/redis-value',
};

const GetRedisCurrentData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.read, { params }).then(callback).catch(error).finally(next);
};

const GetActivationEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.activationEvents, { params }).then(callback).catch(error).finally(next);
};

const GetLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.commandLogs, { params }).then(callback).catch(error).finally(next);
};

const GetPowerLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.powerLogs, { params }).then(callback).catch(error).finally(next);
};

const GetRedisData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(PATH.redisData, { params }).then(callback).catch(error).finally(next);
};

const UpdateRedisValue = (payload, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.redisData}`, payload).then(callback).catch(error).finally(next);
};

export const RootMFRRService = {
    GetRedisCurrentData,
    GetActivationEvents,
    GetLogs,
    GetPowerLogs,
    GetRedisData,
    UpdateRedisValue
};
